module.exports = __webpack_public_path__ + "img/pdfImage.f6770a41.png";